import { copyFor } from 'config';

const getCopy = copyFor('modules.notification.vnmTerms');

export const getTermLinkJoiner = (index, length) => {
  const joiners = getCopy('checkbox.linkJoiners');
  if (index + 1 === length) return joiners[2];
  if (index + 2 === length) return joiners[1];
  return joiners[0];
};

const CATBIRD_UNSUPPORTED_CONTRACT_NAMES = [
  'arcadia_disclosure_personalized_il',
];

export const getTermsUrl = ({
  internalName = '',
  fileUrl,
  id,
}: {
  internalName?: string;
  fileUrl?: string;
  id: number;
}): string => {
  if (
    internalName &&
    CATBIRD_UNSUPPORTED_CONTRACT_NAMES.includes(internalName)
  ) {
    if (fileUrl) return fileUrl;
    else throw new Error('Must provide file URL');
  }

  return `${process.env.ARCADIA_CATBIRD_URL}?id=${id}`;
};

export const dynamicLanguageParam = (href, languageShortCode) => {
  const language = languageShortCode || 'en';
  return `${href}&lang=${language}`;
};
